import { render, staticRenderFns } from "./SelectInputConfig.vue?vue&type=template&id=626a9a37&scoped=true"
import script from "./SelectInputConfig.vue?vue&type=script&lang=js"
export * from "./SelectInputConfig.vue?vue&type=script&lang=js"
import style0 from "./SelectInputConfig.vue?vue&type=style&index=0&id=626a9a37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a9a37",
  null
  
)

export default component.exports